import { PersonalizePartialStoreState, PERSONALIZE_STATE_KEY } from './personalize.reducer';

export const getPersonalizingFinished = (state: PersonalizePartialStoreState) =>
    state[PERSONALIZE_STATE_KEY].personalizingFinished;

export const getError = (state: PersonalizePartialStoreState) => state[PERSONALIZE_STATE_KEY].error;

export const getPersonalizingLoading = (state: PersonalizePartialStoreState) =>
    state[PERSONALIZE_STATE_KEY].personalizingLoading;
